import React from 'react';
import Image from "next/image";
import styles from "../../pages/upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";

import Emioption from '../../assets/images/EMI-Buttons.png';
function emioption() {
    return (

        <div className=''>
           <Image src={Emioption} width='217' height='62'/>
           <div className="row">
           <div className="col-6 col-md-9  text-center pt-2 p-2 ">
                      <a href="https://grayquest.com/institute/shankar-academy-master" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.emibutton}`}>Click Here</button></a>
           </div>
           
        </div>


</div>


    );
}

export default emioption;


